import { FC, useMemo } from "react"
import { Form, Formik } from "formik"
import { Integration } from "../../../../types"
import If from "../../if"
import { useFormIntegrationRef } from "../context"
import { useAppSelector } from "../../../hooks"
import { selectUser } from "../../../../redux/slices/auth"
import {
  integrationSettingsSchema,
  getEmptyIntegrationValues
} from "../form/schema"
import {
  GeneralSettingsSection,
  EmbedTypeSection,
  BrandingAnalyticsSection,
  ModuleConfigurationSection,
  AccessAdvancedSection
} from "./settings/index"

interface Props {
  integration?: Integration
  isLoading: boolean
  onSaveSettings: (integration: Integration) => void
  open?: boolean
}

const Settings: FC<Props> = ({ integration, isLoading, onSaveSettings }) => {
  const user = useAppSelector(selectUser)
  const formRef = useFormIntegrationRef()

  const ownerId = user?.user.id ?? ""
  const initialValues: Integration = useMemo(
    () =>
      integration
        ? { ...integration }
        : getEmptyIntegrationValues(ownerId, "boomtown"),
    [integration, ownerId]
  )

  const showLoader = isLoading && !integration?.id

  return (
    <If
      isLoading={showLoader}
      condition
      then={
        <Formik
          key={String(integration?.id ?? "create")}
          initialValues={initialValues}
          onSubmit={onSaveSettings}
          innerRef={formRef}
          validationSchema={integrationSettingsSchema}
          validateOnBlur
          enableReinitialize={true}
        >
          <Form className="flex flex-col gap-5 [&_label]:text-[11px] [&_label]:font-medium [&_label]:uppercase [&_label]:tracking-wider [&_label]:text-neutral-400 [&_label]:mb-1.5">
            <GeneralSettingsSection />
            <EmbedTypeSection integration={integration} />
            <BrandingAnalyticsSection integration={integration} />
            <ModuleConfigurationSection integration={integration} />
            <AccessAdvancedSection integration={integration} />
          </Form>
        </Formik>
      }
    />
  )
}

export default Settings
